import { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import styles from './SimpleRequestFormEntry.module.scss';

interface Props {
  isTestVariant: boolean;
  jobTypeName: string;
  onSubmit: () => void;
}

const SimpleRequestFormEntry: FC<Props> = ({ jobTypeName, onSubmit, isTestVariant }) => {
  const { t } = useTranslation();
  const options = [
    { id: 'icon-req-1', value: 'yes' },
    { id: 'icon-req-2', value: 'no' },
  ];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {t(`marketingPages:${isTestVariant ? 'AbTestIconRequest.title' : 'SimpleRequest.title'}`, {
          jobType: jobTypeName,
        })}
      </div>
      <div className={styles.buttons}>
        {options.map((option) => (
          <>
            <button
              key={`${option.id}`}
              className={styles['form-entry-button']}
              onClick={() => onSubmit()}
            >
              <div className={styles['button-body']}>
                <div className={styles['image-container']}>
                  <Image
                    alt="label"
                    src={`/static/images/icons/request-${option.value}-icon.svg`}
                    width="48"
                    height="48"
                  />
                </div>
                <div className={styles['form-entry-button-text']}>
                  {t(
                    `marketingPages:${isTestVariant ? 'AbTestIconRequest' : 'SimpleRequest'}.${
                      option.value
                    }`
                  )}
                </div>
              </div>
            </button>
          </>
        ))}
      </div>
    </div>
  );
};

export default SimpleRequestFormEntry;
